import * as React from 'react';
import FastForward from '../../Assets/Player/fast_forward.png';
import FastBackward from '../../Assets/Player/rewind.png';
import PreviousVideo from '../../Assets/Player/previous.png';
import NextVideo from '../../Assets/Player/next.png';
import FrameForward from '../../Assets/Player/frame_forward.png';
import BackwardFrame from '../../Assets/Player/frame_back.png';
import Play from '../../Assets/Player/play.png';
import Pause from '../../Assets/Player/pause.png';
import FastForwardEngaged from '../../Assets/Player/fast_forward.png';
import FastBackwardEngaged from '../../Assets/Player/rewind.png';
import PreviousVideoEngaged from '../../Assets/Player/previous.png';
import NextVideoEngaged from '../../Assets/Player/next.png';
import FrameForwardEngaged from '../../Assets/Player/frame_forward.png';
import BackwardFrameEngaged from '../../Assets/Player/frame_back.png';
import PlayEngaged from '../../Assets/Player/play.png';
import PauseEngaged from '../../Assets/Player/pause.png';

export const controlButtons = [
    {
        name: 'prev-video',
        hint: () => 'Previous Video(Z)',
        icon: () => <img src={PreviousVideo} />,
        engagedIcon: () => <img src={PreviousVideoEngaged} />,
        keyboardEvent: 'KeyZ',
    },
    {
        name: 'fast-backward',
        hint: () => 'Fast backward(A)',
        icon: () => <img src={FastBackward} />,
        engagedIcon: () => <img src={FastBackwardEngaged} />,
        keyboardEvent: 'KeyA',
    },
    {
        name: 'rewind-backward',
        hint: () => 'Backward frame(S)',
        icon: () => <img src={BackwardFrame} />,
        engagedIcon: () => <img src={BackwardFrameEngaged} />,
        keyboardEvent: 'KeyS',
    },
    {
        name: 'play/pause',
        hint: (paused: boolean | undefined) =>
            paused ? 'Play (Space)' : 'Pause (Space)',
        icon: (paused: boolean | undefined) =>
            paused ? <img src={Play} /> : <img src={Pause} />,
        engagedIcon: (paused: boolean | undefined) =>
            paused ? <img src={PlayEngaged} /> : <img src={PauseEngaged} />,
        keyboardEvent: 'Space',
    },
    {
        name: 'rewind-forward',
        hint: () => 'Forward frame(D)',
        icon: () => <img src={FrameForward} />,
        engagedIcon: () => <img src={FrameForwardEngaged} />,
        keyboardEvent: 'KeyD',
    },
    {
        name: 'fast-forward',
        hint: () => 'Fast forward(F)',
        icon: () => <img src={FastForward} />,
        engagedIcon: () => <img src={FastForwardEngaged} />,
        keyboardEvent: 'KeyF',
    },
    {
        name: 'next-video',
        hint: () => 'Next Video(X)',
        icon: () => <img src={NextVideo} />,
        engagedIcon: () => <img src={NextVideoEngaged} />,
        keyboardEvent: 'KeyX',
    },
];
